module.exports = __webpack_public_path__ + "assets/img/966f-hu.svg";